// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 1456 ? "225f8dbd" : chunkId) + "." + {"1456":"6235f72b33ff80a7","3065":"2d716a7b3ef5c363"}[chunkId] + ".js";
};